import { render, staticRenderFns } from "./RiskDetails.vue?vue&type=template&id=b25efb66"
import script from "./RiskDetails.vue?vue&type=script&lang=js"
export * from "./RiskDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports